// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomPatientInsuranceForm from './data'

export default function DataVaxiomPatientInsuranceFormFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomPatientInsuranceForm">
      <DataVaxiomPatientInsuranceForm {...props}>
        {children}
      </DataVaxiomPatientInsuranceForm>
    </Flow>
  )
}
